module.exports = __webpack_public_path__ + "img/telephone.8748aef3.svg";